import { render, staticRenderFns } from "./GlyphCustomization.vue?vue&type=template&id=5abee8c8&scoped=true"
import script from "./GlyphCustomization.vue?vue&type=script&lang=js"
export * from "./GlyphCustomization.vue?vue&type=script&lang=js"
import style0 from "./GlyphCustomization.vue?vue&type=style&index=0&id=5abee8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abee8c8",
  null
  
)

export default component.exports